import React from "react";
import {
  H1,
  Img,
  PostContainer,
  CreatedAt,
  Tags,
  TagsContainer,
  H1Mobile,
} from "./styles";
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { useNavigate } from "react-router-dom";

export const Post = ({
  postImg,
  postTitle,
  postCreatedAt,
  postTags,
  postId,
}) => {
  return (
    <PostContainer>
      <Img $img={require("./logo.png")} />
      <CreatedAt>
        {format(
          new Date(postCreatedAt.substring(0, 10)),
          "EEEE, d\u00a0MMMM, u",
          { locale: ru }
        )}
      </CreatedAt>
      <H1 to={`/about/blog/post/${postId}`} style={{ cursor: "pointer" }}>
        {postTitle}
      </H1>
      <H1Mobile to={`/about/blog/post/${postId}`} style={{ cursor: "pointer" }}>
        {postTitle}
      </H1Mobile>
      <TagsContainer>
        {postTags.map((postTag) => (
          <Tags key={postTag.id}>{postTag.name}</Tags>
        ))}
      </TagsContainer>
    </PostContainer>
  );
};
